// extracted by mini-css-extract-plugin
module.exports = {"details":"_3p09qRgSfze2DLgjNQoK5h","details__info-panel":"_3HM2BW9uX9ulOofgZ2y8vK","details__spec-container":"_2ZWrxDbwgF5bWOqJKiDbcj"};